import MainLayout from "components/Shared/MainLayout";
import MinimalLayout from "components/Shared/MinimalLayout";
import { langs } from "helpers/lang";
import { ROUTES } from "helpers/routes";
import { Language } from "interfaces/locale";
import React, { ReactElement, Suspense, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes } from "react-router-dom";
import LandingPage from "./LandingPage";

const AboutPage = React.lazy(() => import("./AboutPage"));
const CallMeBackPage = React.lazy(() => import("./CallMeBackPage"));
const ContactRequestPage = React.lazy(() => import("./ContactRequestPage"));

const ProjectRoutes = ({ locale }: { locale: Language }): ReactElement => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== locale) i18n.changeLanguage(locale);
  }, [locale, i18n]);

  const redirectLink = locale === langs.pt ? "/" : `/${locale}/`;

  return (
    <Routes>
      <Route
        path="/"
        element={
          <MainLayout>
            <LandingPage />
          </MainLayout>
        }
      />
      <Route
        path={ROUTES[locale].about}
        element={
          <MainLayout>
            <Suspense fallback={null}>
              <AboutPage />
            </Suspense>
          </MainLayout>
        }
      />
      <Route
        path={ROUTES[locale].callMeBack}
        element={
          <MinimalLayout>
            <Suspense fallback={null}>
              <CallMeBackPage />
            </Suspense>
          </MinimalLayout>
        }
      />
      <Route
        path={ROUTES[locale].contactRequest}
        element={
          <MinimalLayout>
            <Suspense fallback={null}>
              <ContactRequestPage />
            </Suspense>
          </MinimalLayout>
        }
      />
      <Route path="*" element={<Navigate to={redirectLink} replace />} />
    </Routes>
  );
};

export default ProjectRoutes;
